import { render, staticRenderFns } from "./OrganizationServiceAccessDropdown.vue?vue&type=template&id=49b72e81&scoped=true&"
import script from "./OrganizationServiceAccessDropdown.vue?vue&type=script&setup=true&lang=js&"
export * from "./OrganizationServiceAccessDropdown.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./OrganizationServiceAccessDropdown.vue?vue&type=style&index=0&id=49b72e81&prod&scoped=true&lang=scss&"
import style1 from "./OrganizationServiceAccessDropdown.vue?vue&type=style&index=1&id=49b72e81&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b72e81",
  null
  
)

export default component.exports